export const UnyieldingFocusIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
            <g clipPath="url(#clip0_2752_3226)">
                <path d="M19.8906 7.17187V1.54688H14.2656" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19.8906 1.54688L7.39062 14.0469" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9.89062 5.29688H2.39062C2.0591 5.29688 1.74116 5.42857 1.50674 5.66299C1.27232 5.89741 1.14063 6.21535 1.14062 6.54687V19.0469C1.14063 19.3784 1.27232 19.6963 1.50674 19.9308C1.74116 20.1652 2.0591 20.2969 2.39062 20.2969H14.8906C15.2221 20.2969 15.5401 20.1652 15.7745 19.9308C16.0089 19.6963 16.1406 19.3784 16.1406 19.0469V11.5469" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_2752_3226">
                    <rect width="20" height="20" fill="white" transform="translate(0.515625 0.923584)" />
                </clipPath>
            </defs>
        </svg>
    )
}